module.exports = __webpack_public_path__ + "static/media/playbackright.1402c785.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/playbackright.svg
// module id = 1580
// module chunks = 1